View = require 'view'
$ = require 'jquery'
mixin = require 'lib/mixin'
TabbedPaneView = require 'views/internal/tabbed-pane-view'
template = require 'views/templates/enterprise_detail_loading'

module.exports = class EnterpriseAdminDashboardLoadingView extends View
  mixin TabbedPaneView, @

  initialize: ->
    super

  render: ->
    @$el.html template
      displayName: @model.get('displayName')
      enforcesSso: @model.get('prefs').ssoOnly

    @



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/enterprise-admin-dashboard-loading-view.coffee